export enum EventTypes {
    SUCCESS_CREATE_EVENT = 'SUCCESS_CREATE_EVENT',
    ERROR_CREATE_EVENT = 'ERROR_CREATE_EVENT',
    MORE_PARAMS_CLICK_CREATE_EVENT = 'MORE_PARAMS_CLICK_CREATE_EVENT',
    DOMReady = 'DOMReady',
    CONTENT_SIZE_CHANGED_CREATE_EVENT = 'CONTENT_SIZE_CHANGED_CREATE_EVENT',
}

export interface IframeSize {
    width?: number;
    height?: number;
}

export interface PostMessage {
    event: EventTypes;
    payload?: string | IframeSize;
}
